import styled, { css } from 'styled-components';
import { spacing, colors, largeShadow, body2, easing, duration } from 'ui/theme';
import { SecondaryButton, Button, IconButton } from 'ui/button';

type StyledSecondaryProps = {
  isShowingDropdown?: boolean;
  limitWidth?: boolean;
};

export const StyledContentDropdown = css`
  position: absolute;
  border-radius: ${spacing.threeEights};
  min-width: ${spacing.x12};
  width: max-content;
  max-width: ${spacing.x32};
  background: ${colors.backgroundPrimary};
  ${largeShadow};
  z-index: 3;
`;

export const StyledItem = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  padding: ${spacing.half};
  ${body2};
  border-radius: ${spacing.quarter};
  &:hover {
    background: ${colors.backgroundPrimaryHover};
  }
`;

export const StyledDropdownWrapper = styled.div`
  position: relative;
`;

export const StyledOptionMenu = styled.div`
  ${StyledContentDropdown};
  padding: ${spacing.threeEights};
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  margin-top: ${spacing.threeQuarter};
`;

export const StyledSecondary = styled(Button)<StyledSecondaryProps>`
  &&& {
    ${(props) =>
      props.limitWidth
        ? `
      width: -moz-available;
      width: -webkit-fill-available;
      width: fill-available;
      `
        : ''}
    background: ${(props) => (props.isShowingDropdown ? colors.white : colors.purple10)};
    border: ${(props) =>
      props.isShowingDropdown
        ? `${spacing.single} solid ${colors.purple50}`
        : `${spacing.single} solid transparent`};
    color: ${colors.purple90};

    box-shadow: none;
    &:hover {
      border: ${spacing.single} solid ${colors.purple50};
    }
    line-height: ${spacing.plusHalf};
    min-width: 0;
    > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      justify-content: flex-start;
    }
  }
`;

export const StyledFilterRow = styled.div<{ isDarkTheme?: boolean; isPropertyChanges?: boolean }>`
  display: flex;
  align-items: center;
  border-radius: ${spacing.quarter};
  padding: ${({ isPropertyChanges }) => (isPropertyChanges ? '0' : spacing.quarter)};
  margin: ${({ isPropertyChanges }) => (isPropertyChanges ? '0' : `${spacing.threeQuarter} 0 0`)};
  position: relative;
  gap: ${spacing.half};
  transition: all ${duration.short} ${easing.exit};
  ${({ isPropertyChanges, isDarkTheme }: { isPropertyChanges?: boolean; isDarkTheme?: boolean }) =>
    !isPropertyChanges &&
    `
    &:hover {
      background: ${isDarkTheme ? colors.white : colors.grey5};
      transition: all ${duration.short} ${easing.entrance};
    }
  `}
  > div {
    min-width: 0;
  }
`;

export const StyledClose = styled(IconButton)<{ isDarkTheme?: boolean }>`
  opacity: 0;
  margin-left: auto;
  ${StyledFilterRow}:hover & {
    opacity: 1;
  }
  ${({ isDarkTheme }) =>
    !isDarkTheme &&
    `
    &&&:hover {
      background: ${colors.backgroundTertiaryHover};
    }
  `}
`;

export const StyledFilterDropdown = styled.div`
  ${StyledContentDropdown};
  top: ${spacing.x3};
  display: flex;
`;

export const StyledPaddedOptionMenu = styled.div`
  ${StyledContentDropdown};
  top: ${spacing.x3};
  padding: ${spacing.threeEights};
`;
